import { useContext, useEffect, useState } from 'react';
import Input from '../../../../components/Inputs/Input';
import './FinanceForm.css';
import CheckboxField from '../../../../components/Checkbox/CheckboxField';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { useDropdownConfig } from '../../../../contexts/DropdownsContext';
import Dropdowns from '../../../../components/Dropdowns/Dropdowns';
import { createGlPartInfo, getFinanceInfo, getGlAccountInfo, updateGlPartInfo } from '../../services/FinanceService';
import { HTTP_RESPONSE_CODES } from '../../../../globals/globals';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { SectionPlaceholder } from './SectionPlaceholder';
import engineeringImg from '../../../../assets/Images/engineering-placeholder.svg';


const generalSectionButtons = [
  { label: 'Save and Finish', icon: "icon-save", id: 'save' },
  { label: 'Save and Continue Editing', icon: "icon-save", id: 'save-continue' },
  { label: 'Cancel', icon: "icon-cross", id: 'cancel', type: 'danger' }
];


const FinanceForm = ({ onChange, open, part, disabled }) => {

  const [errorState, setErrorState] = useState({});
  const [editing, setEditing] = useState(false);
  const glAccountDrpdwn = useDropdownConfig(78);

  // Form
  const [calculatedValues, setCalculatedValues] = useState({
    listCost: "",
    averageCost: "",
    currencyName: "",
    secCurrencyName: "",
    secondaryCurrencyAverageCost: "",
  });

  const [values, setValues] = useState({
    depreciationControlled: false,
    inventoryAccount: null,
    expenseAccount: null,
    depreciationAccount: null,
    writeOffAccount: null
  });
  const [backup, setBackup] = useState({
    depreciationControlled: false,
    inventoryAccount: null,
    expenseAccount: null,
    depreciationAccount: null,
    writeOffAccount: null
  });

  useEffect(() => {
    if (open && part) {
      getFinanceInfo(part.id).then(response => {
        let costs = response.data.load;
        setCalculatedValues(
          {
            listCost: costs.averageCost.toFixed(2),
            averageCost: costs.averageCost.toFixed(2),
            currencyName: costs.currencyName,
            secondaryCurrencyAverageCost: costs.secundaryCurrencyAverageCost.toFixed(2),
            secCurrencyName: "CAD"
          }
        )
      })
      getGlAccountInfo(part.id).then(glAccResponse => {
        if (glAccResponse.data.responseCode === 200) {
          let glAccInfo = glAccResponse.data.load;
          //TODO: setAccount info to the values
          if (glAccInfo) {
            setValues(glAccInfo);
            setBackup(glAccInfo);
          }

        }
      })
    }
  }, [open, part]);


  // TODO: use permission context
  const hasPermission = () => { return true }

  const { successMsg, infoMsg, warningMsg } = useSnackBar();

  const saveSection = async (closeEdition) => {
    infoMsg("Saving finance information");
    if (typeof (values.id) !== 'number') {
      let postResponse = await createGlPartInfo({ ...values, part }, part.id);
      if (postResponse.data.responseCode === HTTP_RESPONSE_CODES.CREATED) {
        updateGlPartInfo({ ...postResponse.data.load, ...values, part }, part.id).then(updateResponse => {
          if (updateResponse.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
            successMsg("Finance information saved");
            setValues(updateResponse.data.load);
            setBackup(updateResponse.data.load);
            if (closeEdition) setEditing(false);
          }
          else {
            warningMsg(updateResponse.data.message, updateResponse.data.validationErrors?.map(e => e.error).join(', '))
          }
        });
      }
    } else {
      updateGlPartInfo({ ...values, part }, part.id).then(updateResponse => {
        if (updateResponse.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
          successMsg("Finance information saved");
          setValues(updateResponse.data.load);
          setBackup(updateResponse.data.load);
          if (closeEdition) setEditing(false);
        } else {
          warningMsg(updateResponse.data.message, updateResponse.data.validationErrors?.map(e => e.error).join(', '))
        }
      });
    }
  }

  const cancelEdit = () => {
    setEditing(false);
    setValues(backup);
  }

  const changeValue = (e) => {
    let { name, value } = e;
    setValues(prev => ({ ...prev, [name]: value }));
  }

  const handleDropdown = (acc, name) => {
    changeValue({ name, value: acc.id });
    // TODO: handle clear dropdowns;

  }

  return (open &&
    <div className='finance-form-wrapper'>
      <div className='section-header'>
        {/* {JSON.stringify(part)} */}
        <div className='title-container'>
          <b>Finance</b>
          {!editing && hasPermission('update') && (part?.version > 0) && <button className='outlined iconTextButton small-size' onClick={() => setEditing(true)}>
            <i className='icon-edit'></i>
            <span>
              Edit
            </span>
          </button>}
        </div>
        {editing && hasPermission('update') && <MultioptionButton buttonCallbacks={{
          'save': () => saveSection(true),
          'save-continue': () => saveSection(false),
          'cancel': () => cancelEdit()
        }} buttons={generalSectionButtons} />}
      </div>
     {part?.version > 0 ? <div className="finance-form-component">
        {/* <input placeholder="*PN"></input> */}
        <Input suffix={calculatedValues.currencyName} error={errorState["listCost"]} isNumeric value={calculatedValues.listCost} disabled={true} maxLength="50" name="listCost" label={"List Cost"} onChange={changeValue} />
        <Input suffix={calculatedValues.currencyName} error={errorState["avgCost"]} isNumeric value={calculatedValues.averageCost} disabled={true} name="avgCost" label={"Average Cost"} onChange={changeValue} />
        {/* <Input error={errorState["secCurrency"]}  disabled={!editing} name="secCurrency" label={"Secondary Currency"} onChange={changeValue} /> */}
        {/* <Dropdowns disabled={!editing} data={currencyDrpdwn.config}/> */}
        {/* <div className='checkboxes'> */}


        <CheckboxField disabled={!editing} outlined checked={values.depreciationControlled} onChange={(e) => changeValue({ name: "depreciationControlled", value: e })}>
          <span>
            Depreciation Controlled
          </span>
        </CheckboxField>
        <Input suffix={calculatedValues.secCurrencyName} error={errorState["avgCostSecCurrency"]} isNumeric value={calculatedValues.secondaryCurrencyAverageCost} disabled={true} name="avgCostSecCurrency" label={"Average Cost - Secondary Currency"} onChange={changeValue} />


        <div className='gl-accounts'>
          <b className='title'>GL Accounts</b>

          <b className='input-label'>Inventory Account</b>
          <Dropdowns preSelectValue={values.inventoryAccount} onOptionSelect={(acc) => handleDropdown(acc, "inventoryAccount")} optionLabel="name" disabled={!editing} data={glAccountDrpdwn.config} />
          {/* <Input label="GL Code/Name"/> */}
          <b className='input-label'>Expense Account</b>
          <Dropdowns preSelectValue={values.expenseAccount} onOptionSelect={(acc) => handleDropdown(acc, "expenseAccount")} optionLabel="name" disabled={!editing} data={glAccountDrpdwn.config} />

          <b className='input-label'>Depreciation Account</b>
          <Dropdowns preSelectValue={values.depreciationAccount} onOptionSelect={(acc) => handleDropdown(acc, "depreciationAccount")} optionLabel="name" disabled={!editing} data={glAccountDrpdwn.config} />

          <b className='input-label'>Write - Off Account</b>
          <Dropdowns preSelectValue={values.writeOffAccount} onOptionSelect={(acc) => handleDropdown(acc, "writeOffAccount")} optionLabel="name" disabled={!editing} data={glAccountDrpdwn.config} />
        </div>

        {/* <Dropdowns isStatic disabled={!editing} data={glAccountDrpdwn.config}/> */}

        {/* <Input error={errorState["description"]}  disabled={!editing} name="GL Account" label={"GL Account"} value={""} onChange={changeValue} /> */}


        {/* </div> */}


      </div>
      : <SectionPlaceholder title="There are no configurations in this panel" subTitle="Save the General Information to enable this section" image={engineeringImg}/>}
    </div>
  )
}

export default FinanceForm;